module.exports = function (data) {
var __t, __p = '';
__p += '\r\n<ol id="voting-result-selections" class="selections"></ol>\r\n\r\n<button class="spider right prevScreen">\r\n        <img src="./assets/Spider.svg" alt="next"/>\r\n        <span class="label">Play the story</span>\r\n</button>';
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/views/Results.ejs
// module id = 11
// module chunks = 0